(function() {

    /**
     * @module inPageNav
     */
    var inPageNav = {};

    /**
     * Create in page nav from headings
     * 
     * @memberof module:inPageNav
     */
    inPageNav.init = function() {
        var navs = document.querySelectorAll('.qld__inpage-nav-links');
        var mainEl = document.querySelector('main.main');
        var isLandingPage = mainEl && mainEl.classList.contains('landing');
        const DEFAULT_ELEMENT_ID = 'content';
        const DEFAULT_HEADING = 'h2';

        // For all In-Page Nav components
        navs.forEach(function(nav) {

            var headingSelector = nav.getAttribute('data-heading_tag')
                ? nav.getAttribute('data-heading_tag')
                : DEFAULT_HEADING;

            var pageContent = isLandingPage
                ? mainEl
                : document.getElementById(DEFAULT_ELEMENT_ID);

            if (nav.dataset.targetid) {
                pageContent = document.getElementById(nav.dataset.targetid);
            }

            if (!pageContent) {
                return;
            }

            var headings = [];

            // Custom selector mode
            if (headingSelector === 'custom') {

                // Get unique, non-empty selectors
                var customSelectors = [
                    ...new Set(
                        (nav.dataset.customSelectors || '')
                            .split(',')
                            .map(function(selector) {
                                return selector.trim();
                            })
                            .filter(Boolean)
                    )
                ];

                // Collect all matching elements
                customSelectors.forEach(function(selector) {
                    headings.push(
                        ...Array.from(pageContent.querySelectorAll(selector))
                    );
                });

                // Remove duplicate elements only in custom mode
                headings = [...new Set(headings)];

                // Preserve DOM order
                headings.sort(function(a, b) {
                    if (a === b) {
                        return 0;
                    }

                    return a.compareDocumentPosition(b) &
                        Node.DOCUMENT_POSITION_FOLLOWING
                            ? -1
                            : 1;
                });

                // Exclude component heading and banner headings
                headings = headings.filter(function(element) {
                    return !element.classList.contains('qld__inpage-nav-links__heading') &&
                        !element.classList.contains('banner__heading');
                });

            } else {
                headings = Array.from(
                    pageContent.querySelectorAll(
                        headingSelector +
                        ':not(.qld__inpage-nav-links__heading):not(.banner__heading)'
                    )
                );
            }

            var list = nav.querySelector('.qld__link-list');

            if (!list) {
                return;
            }

            list.innerHTML = '';

            if (headings.length === 0) {
                console.warn('no headings found');
                nav.style.display = 'none';
            }

            headings.forEach(function(heading) {

                var title = heading.innerText
                    ? heading.innerText.trim()
                    : '';

                if (!title) {
                    return;
                }

                var id = heading.getAttribute('id');

                if (!id) {
                    id = 'section__' + title
                        .toLowerCase()
                        .replace(/\s+/g, '-')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#039;');

                    heading.setAttribute('id', id);
                }

                heading.setAttribute('tabindex', -1);

                var li = document.createElement('li');
                var a = document.createElement('a');

                a.textContent = title;
                a.href = '#' + id;

                li.appendChild(a);

                // Append link item if it doesn't already exist in list
                if (
                    list.querySelector(
                        'a[href="' + a.getAttribute('href') + '"]'
                    ) === null
                ) {
                    list.appendChild(li);
                }
            });
        });
    }

    QLD.inPageNav = inPageNav;

    // Init In Page Nav on document load
    document.addEventListener('DOMContentLoaded', QLD.inPageNav.init);
})();